import React from 'react'

const PerPageContext = React.createContext<number>(0)

export function PerPageProvider({children, perPage}: React.PropsWithChildren<{perPage: number}>) {
  return <PerPageContext value={perPage}>{children}</PerPageContext>
}

export function usePerPage() {
  return React.use(PerPageContext)
}

try{ PerPageContext.displayName ||= 'PerPageContext' } catch {}
try{ PerPageProvider.displayName ||= 'PerPageProvider' } catch {}